import { Link } from 'react-router-dom';
import '../../css/home/HomeFooter.css';
import { useLang } from '../../i18n';

const SPORTS_LINKS = [
  { key: 'home.footer.sportsBetting',      to: '/sports' },
  { key: 'home.footer.sportsBettingTerms', to: '/terms'  },
];

const ABOUT_LINKS = [
  { key: 'home.footer.aboutUs',           to: '/about'   },
  { key: 'home.footer.termsConditions',   to: '/terms'   },
  { key: 'home.footer.responsibleGaming', to: '/license' },
  { key: 'home.footer.privacyPolicy',     to: '/privacy' },
  { key: 'home.footer.kycPolicy',         to: '/kyc'     },
  { key: 'home.footer.helpCenter',        to: '/help'    },
];

const PAY = ['VISA', 'Mastercard', 'Apple Pay', 'Google Pay', '₿ BTC', 'Ξ ETH', '₮ USDT'];

const SOCIALS = [
  // Telegram
  { label: 'Telegram', href: 'https://t.me/officialsupport_bet', d: <path d="M21.9 5.4l-3 14.1c-.2 1-.8 1.2-1.7.8l-4.6-3.4-2.2 2.1c-.2.2-.4.4-.9.4l.3-4.7 8.5-7.7c.4-.3-.1-.5-.6-.2L7.5 13 3 11.6c-1-.3-1-1 .2-1.5l17.2-6.6c.8-.3 1.5.2 1.5 1.9z" /> },
];

export default function HomeFooter() {
  const { t } = useLang();
  const scrollToTop = () => {
    const screen = document.querySelector('.phone-screen');
    if (screen) screen.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="home-footer">
      <div className="footer-toptop">
        <button onClick={scrollToTop} aria-label="Back to top">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 13V4M4 7l4-4 4 4" stroke="rgba(255,255,255,.8)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>

      <div className="footer-main">
        <div className="footer-brand">
          <Link to="/" className="footer-logo-link">
            <img src="/logo.png" alt="Roxs Sports" className="footer-logo" />
          </Link>
          <p className="footer-tagline">{t('home.footer.tagline')}</p>
          <a href="mailto:support@roxs-sports.com" className="footer-email">support@roxs-sports.com</a>
          <div className="footer-socials">
            {SOCIALS.map((s) => (
              <a key={s.label} className="footer-soc" href={s.href} aria-label={s.label}>
                <svg width="17" height="17" viewBox="0 0 24 24" fill="#cfcfe0">{s.d}</svg>
              </a>
            ))}
          </div>
        </div>

        <div className="footer-cols">
          <div className="footer-col">
            <h4 className="footer-col-title">{t('home.footer.colSports')}</h4>
            {SPORTS_LINKS.map(({ key, to }) => (
              <Link key={key} className="footer-link" to={to}>{t(key)}</Link>
            ))}
          </div>
          <div className="footer-col">
            <h4 className="footer-col-title">{t('home.footer.colAbout')}</h4>
            {ABOUT_LINKS.map(({ key, to }) => (
              <Link key={key} className="footer-link" to={to}>{t(key)}</Link>
            ))}
          </div>
        </div>
      </div>

      <div className="footer-pay">
        {PAY.map((p) => (
          <span className="pay-chip" key={p}>{p}</span>
        ))}
      </div>

      <div className="footer-license-block">
        <p className="footer-license-text">{t('home.footer.licenseText')}</p>
        <p className="footer-license-text footer-license-sub">{t('home.footer.disclaimer')}</p>
        <div className="footer-bottom">
          <div className="footer-18">
            <span className="badge18">18+</span>
            <span className="footer-license">{t('common.licensed')}</span>
          </div>
          <span className="footer-copy">{t('common.copyright')}</span>
        </div>
      </div>
    </footer>
  );
}
